import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class BlockTimesProximityActions {
    static openBlockTimesProximityDialogFromAngularJS = createAction('[Admin:User:BlockTimes:Proximity] ' +
        'Open BlockTimes and Proximity Dialog (from Angular JS)', props<{blockTimes: any, proximity: any}>());

    static updateBlockTimeAndProximity =
        createAction('[Admin:User:BlockTimes:Proximity] Update Block Time and Proximity', props<{blockTimes: any, proximity: any, isCancelled: boolean}>());
}
